import React, { Component } from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import IComponent from './../../interfaces/IComponent.js';
import Utils from './../../utils/utils.js';

let zi_temp = 5;
let id_temp = 0;
// ORDER PROPERTIES BY GROUP

@observer
class HTMLElement extends IComponent {
  dragging = false;
  dragStart = {};

  @observable bounds = {};
  @observable
  transformControls = {
    hidden: true
  };

  @observable width = 0;
  @observable height = 0;
  @observable zIndex = 0;

  //text relative
  @observable editing = false;
  @observable value = "";

  constructor(props) {
    super(props, []);
    this.__key = "HTMLElement";
    this.owner = props.owner;
    this.zIndex = zi_temp++;
    this.type = this.props.type;
    this.tag = this.props.tag
    this.id = id_temp++;
    console.log("New element #" + this.id, this.type);
    // this.value = this.props.children
    if (this.isText()) {
      this.value = this.props.children.props.children;
    }
  }

  updateStylesBasedOnProperties() {
    // this.getPropertiesObject().forEach(prop => {
    //   this.getElement().style[prop.key] = prop.value;
    // })
  }

  onPropertyUpdate(prop) {
    // console.log(prop.key, prop.value);
    // this.updateStylesBasedOnProperties()
    this.getElement().style[prop.key] = prop.value;
  }

  isText() {
    return this.type === "text";
  }

  componentDidMount() {
    this.bounds = this.getBounds();
    this.getElement().style.zIndex = this.zIndex;

    this.owner.addRef(this);
    this.selectionTool = this.owner.props.parent.toolbar.getToolComponent(
      "selection"
    );
    this.documentContainer = this.owner.props.parent;

    if (this.isText()) {
      // console.log('ok');
      this.on("dblclick", this.triggerEdit.bind(this));
    }

    this.owner.props.parent.refs.container.addEventListener(
      "mousemove",
      this.handleMouseMove.bind(this)
    );
    document.addEventListener("mouseup", this.handleMouseUp.bind(this), false);
    this.updateProperties();
  }

  getInput(key) {
    return this.documentContainer.getInput(key);
  }

  componentWillUnmount() {
    document.removeEventListener(
      "mouseup",
      this.handleMouseUp.bind(this),
      false
    );
    this.owner.props.parent.refs.container.removeEventListener(
      "mousemove",
      this.handleMouseMove.bind(this)
    );
    // this.__removeON("click", this.onClick.bind(this));
    this.owner.removeRef(this);
    console.log("Element #" + this.id + " dead.");
  }

  triggerEdit(e) {
    if (
      this.owner.props.parent.toolbar.currentTool.name.toLowerCase() !== "selection" &&
      this.owner.props.parent.toolbar.currentTool.name.toLowerCase() !== "text"
    )
      return;
    e.preventDefault();
    e.stopPropagation();
    this.editing = true;
    this.updateTransformControls();
  }

  stopEdit(e) {
    if (this.editing) {
      this.editing = false;
      this.getElement().innerText = this.value;
    }
  }

  hasParent() {
    return this.props.parentId;
  }

  // Helper function to get an element's exact position
  getPosition() {
    var xPos = 0;
    var yPos = 0;
    let el = this.refs.element;
    xPos = el.offsetLeft - el.scrollLeft + el.clientLeft;
    yPos = el.offsetTop - el.scrollTop + el.clientTop;
    return {
      x: xPos,
      y: yPos
    };
  }

  getBoundingClientRect() {
    return this.getElement().getBoundingClientRect();
  }

  getBounds() {
    const b = this.getBoundingClientRect();
    const f = this.getFactor();
    this.width = b.width / f;
    this.height = b.height / f;
    const p = this.getPosition();
    this.x = p.x;
    this.y = p.y;
    return {
      x: this.x,
      y: this.y,
      width: this.width,
      height: this.height
    };
  }

  hideTransformControls() {
    this.transformControls.hidden = true;
    this.stopEdit();
  }

  getFactor() {
    return this.owner.props.parent.zoom;
  }

  showTransformControls() {
    const b = this.getBounds();

    this.transformControls = {
      x: b.x,
      y: b.y,
      width: b.width,
      height: b.height,
      hidden: false
    };
  }

  updateTransformControls() {
    const b = this.getBounds();

    this.transformControls = {
      x: b.x,
      y: b.y,
      width: b.width,
      height: b.height,
      hidden: this.transformControls.hidden
    };
    // console.log('update');
    // this.updateProperties()
    // this.owner.props.parent.toolbar.document.notifyPanel("selectionChanged", this);
    // this.owner.props.parent.toolbar.document.notifyPanel("update");
  }

  getElement() {
    return this.refs.element;
  }

  on(evt, handler) {
    this.refs.element.addEventListener(evt, handler);
  }

  __removeON(evt, handler) {
    this.refs.element.removeEventListener(evt, handler);
  }

  componentDidUpdate() {
    this.bounds = this.refs.element.getBoundingClientRect();
    if (this.refs.textEdit) {
      this.refs.textEdit.focus();
    }
  }

  handleMouseMove(e) {
    if (this.dragging) {
      const f = this.getFactor();
      const x = e.clientX,
        y = e.clientY;
      const prev = this.dragStart.prev;
      const deltaX = (x - this.dragStart.x) / f;
      const deltaY = (y - this.dragStart.y) / f;

      const isAlt = this.getInput('Alt');

      e.preventDefault();
      e.stopPropagation();

      switch (this.dir) {
        case "N":
          if(isAlt) {
            this.setTop(prev.y + deltaY);
            this.setHeight(prev.h - deltaY * 2);
          } else {
            this.setTop(prev.y + deltaY);
            this.setHeight(prev.h - deltaY);
          }
          break;

        case "S":
          if(isAlt) {
            this.setTop(prev.y - deltaY);
            this.setHeight(prev.h + deltaY * 2);
          } else {
            this.setTop(prev.y);
            this.setHeight(prev.h + deltaY);
          }
          break;

        case "E":
          if(isAlt) {
            this.setLeft(prev.x - deltaX)
            this.setWidth(prev.w + 2 * deltaX);
          } else {
            this.setLeft(prev.x)
            this.setWidth(prev.w + deltaX);
          }
          break;

        case "W":
          if(isAlt) {
            this.setWidth(prev.w - 2 * deltaX);
            this.setLeft(prev.x + deltaX);
          } else {
            this.setWidth(prev.w - deltaX);
            this.setLeft(prev.x + deltaX);
          }

          break;

        case "NW":
          if(isAlt) {
            this.setTop(prev.y + deltaY);
            this.setHeight(prev.h - deltaY * 2);
            this.setWidth(prev.w - 2 * deltaX);
            this.setLeft(prev.x + deltaX);
          } else {
            this.setTop(prev.y + deltaY);
            this.setHeight(prev.h - deltaY);
            this.setWidth(prev.w - deltaX);
            this.setLeft(prev.x + deltaX);
          }
          break;

        case "NE":
          if(isAlt) {
            this.setTop(prev.y + deltaY);
            this.setHeight(prev.h - deltaY * 2);
            this.setLeft(prev.x - deltaX)
            this.setWidth(prev.w + 2 * deltaX);
          } else {
            this.setTop(prev.y + deltaY);
            this.setHeight(prev.h - deltaY);
            this.setLeft(prev.x)
            this.setWidth(prev.w + deltaX);
          }
          break;

        case "SW":
          if(isAlt) {
            this.setTop(prev.y - deltaY);
            this.setHeight(prev.h + deltaY * 2);
            this.setWidth(prev.w - 2 * deltaX);
            this.setLeft(prev.x + deltaX);
          } else {
            this.setTop(prev.y);
            this.setHeight(prev.h + deltaY);
            this.setWidth(prev.w - deltaX);
            this.setLeft(prev.x + deltaX);
          }
          break;

        case "SE":
          if(isAlt) {
            this.setTop(prev.y - deltaY);
            this.setHeight(prev.h + deltaY * 2);
            this.setLeft(prev.x - deltaX)
            this.setWidth(prev.w + 2 * deltaX);
          } else {
            this.setTop(prev.y);
            this.setHeight(prev.h + deltaY);
            this.setLeft(prev.x)
            this.setWidth(prev.w + deltaX);
          }
          break;

        default:
          break;
      }

      this.selectionTool.updateAllTransformControls();
    }
  }

  setLeft(x, update = true) {
    this.setValue("left", x + "px");
    if (update) this.x = x;
    else {
      if (this.x !== x) this.x = x;
    }
  }

  setTop(y, update = true) {
    this.setValue("top", y + "px");
    if (update) this.y = y;
    // this.updateTransformControls();
  }

  setWidth(w) {
    // this.getElement().style.width = w + "px";
    this.setValue("width", w + "px");
    this.width = w;
  }

  setHeight(h) {
    // /*if (!this.isText())*/ this.getElement().style.height = h + "px";
    // else this.getElement().style.lineHeight = h + "px";
    this.setValue("height", h + "px");
    this.height = h;
    // this.updateTransformControls();
  }

  handleMouseUp(e) {
    if (this.dragging) {
      this.dragging = false;
      this.selectionTool.resizing = false;
    }
  }

  getElementId() {
    return this.getElement().id
  }

  updateProperties() {

    const props = [];
    let styles = Utils.getStylesWithoutDefaults(this.getElement());
    const ts = window.getComputedStyle(this.getElement());
    if(this.isText()) {
      ["color", "textAlign", "textDecoration", "textIndent", "textOverflow", "textShadow", "textTransform", "font", "fontFamily", "fontSize", "fontStyle", "fontVariant", "fontWeight"].forEach(k => {
        styles[k] = ts[k];
      })
    }

    if(this.getElementId().trim().length) {
      styles["id"] = this.getElementId();
    }

    // let styles = window.getComputedStyle(this.getElement());

    if(!styles) return [];

    Object.keys(styles).forEach(k => {
      if(!k) return;
      if(styles[k].trim().length === 0) return;
      if(isNaN(Number(k))) {
        let prop = {};
        if(k.toLowerCase().endsWith('color')) {
          prop = {
            type: "color",
            key: k,
            value: styles[k]
          }
        } else {
          prop = {
            type: "string",
            key: k,
            value: styles[k]
          }
        }
        props.push(prop);
      }
    });
    this.setProperties(props);
    return props;
  }

  handleResizeStart(evt, dir) {
    evt.preventDefault();
    evt.stopPropagation();
    this.dragging = true;
    this.dir = dir;
    this.dragStart = {
      x: evt.clientX,
      y: evt.clientY,
      prev: {
        w: this.width,
        h: this.height,
        x: this.x,
        y: this.y
      }
    };
    this.selectionTool.resizing = true;
  }

  getTransformControls() {
    if (this.transformControls && !this.transformControls.hidden) {
      const c = this.transformControls;
      const f = this.getFactor();
      const s = 8 / f;
      const bw = 2 / f;
      return (
        <div
          ref="transformControls"
          style={{
            position: "absolute",
            top: c.y - s / 2,
            left: c.x - s / 2,
            width: c.width + s,
            height: c.height + s,
            visibility: c.hidden ? "hidden" : "visible",
            pointerEvents: "none",
            zIndex: "2000"
          }}
        >
          <div
            style={{
              position: "absolute",
              top: s / 2,
              left: s / 2,
              width: c.width - 3 / f,
              height: c.height - 3 / f,
              border: bw + "px solid rgb(71, 154, 249)"
            }}
          />

          <div style={this.anchorStyle("NW")} onMouseDown={e => this.handleResizeStart(e, "NW")} />
          <div style={this.anchorStyle("N")} onMouseDown={e => this.handleResizeStart(e, "N")}/>
          <div style={this.anchorStyle("NE")} onMouseDown={e => this.handleResizeStart(e, "NE")}/>
          <div style={this.anchorStyle("E")} onMouseDown={e => this.handleResizeStart(e, "E")}/>
          <div style={this.anchorStyle("SE")} onMouseDown={e => this.handleResizeStart(e, "SE")}/>
          <div style={this.anchorStyle("S")} onMouseDown={e => this.handleResizeStart(e, "S")}/>
          <div style={this.anchorStyle("SW")} onMouseDown={e => this.handleResizeStart(e, "SW")}/>
          <div style={this.anchorStyle("W")} onMouseDown={e => this.handleResizeStart(e, "W")}/>
        </div>
      );
    } else return null;
  }

  anchorStyle(dir) {
    const f = this.getFactor();
    const s = 8 / f;
    const bw = 2 / f;

    let top,
      left,
      tx = "-100%",
      ty = "-100%";
    switch (dir) {
      case "NW":
        top = 0;
        left = 0;
        tx = "0";
        ty = "0";
        break;
      case "NE":
        top = 0;
        left = "100%";
        tx = "-100%";
        ty = "0";
        break;
      case "SE":
        top = "100%";
        left = "100%";
        break;
      case "SW":
        top = "100%";
        left = 0;
        tx = "0%";
        ty = "-100%";
        break;
      case "N":
        top = 0;
        left = "50%";
        tx = "-50%";
        ty = "0";
        break;
      case "S":
        top = "100%";
        left = "50%";
        tx = "-50%";
        break;
      case "E":
        top = "50%";
        left = "100%";
        ty = "-50%";
        break;
      case "W":
        top = "50%";
        left = 0;
        ty = "-50%";
        tx = "0";
        break;
      default:
        break;
    }

    return {
      pointerEvents: "all",
      position: "absolute",
      width: s,
      height: s,
      background: "white",
      border: bw + "px solid rgb(71, 157, 249)",
      top,
      left,
      transform: "translate(" + tx + ", " + ty + ")",
      transformOrigin: 'center center'
    };
  }

  getChildComponents() {
    
  }

  getChilds() {
    return React.Children.map(this.props.children, (child, index) => {
      // console.log(child);
      if (index === 0) {
        const childs = [];
        if (this.isText() && this.editing)
          childs.push(
            <textarea
              ref="textEdit"
              onChange={e => {
                this.value = e.target.value;
              }}
              type="text"
              value={this.value}
              style={{
                fontSize: "inherit",
                border: "none",
                outline: "none",
                width: this.width,
                height: this.height,
                textAlign: window.getComputedStyle(this.getElement()).textAlign,
                fontWeight: window.getComputedStyle(this.getElement())
                  .fontWeight,
                fontFamily: window.getComputedStyle(this.getElement())
                  .fontFamily,
                maxWidth: this.width,
                overflow: 'hidden',
                background: 'none',
                resize: 'none',
                color: 'inherit',
                lineHeight: 'inherit'
              }}
            />
          );
        return React.cloneElement(
          child,
          {
            ref: "element"
          },
          ...childs
        );
      } else {
        return child;
      }
    });
  }

  render() {
    // console.log(this.props.children)
    return (
      <React.Fragment>
        {this.getChilds()}
        {this.getTransformControls()}
      </React.Fragment>
    );
  }
}

export default HTMLElement;



// WEBPACK FOOTER //
// ./src/components/document/HTMLElement.js